<template>
    <div>
        <div class="booking-section sdr-box" style="padding:0px; padding-top: 10px;" v-for="(item, index) in get_RebookingTickets({ idFlight: flight.idFlight, whichCall: whichcall })" v-bind:key="index">
            <!-- >>> 'Pax Headline Rebooking, Mode: 'overview' ------------- -->
            <h4 class="paxheadline" v-if="mode !=='rebookingpassengers'" v-bind:class="{ flightIsNotRebookable: flight.rebookable === false }">
                {{ trnslPaxSalutations(item.pax.salutation) }} {{ item.pax.firstName }} {{ item.pax.lastName }} ({{ born[getCurrentLocale] }}: {{ item.pax.birthdate | birthdate }})
            </h4>


            <!-- >>> 'Pax Headline Rebooking, Mode: 'rebookingpassengers' -- -->
            <div class="outerbox" v-if="mode ==='rebookingpassengers'">
                <div class="mybox">
                    <input type="checkbox"
                    :disabled="flight.rebookable === false"
                    :id="'singlePax_' + flight.idFlight + '_' + item.pax.idPax + '_' + flightdirection + '_' + item.pax.salutation + '_' + item.ticket.idTicket"
                    :name="'singlePax_' + flight.idFlight + '_' + item.pax.idPax + '_' + flightdirection + '_' + item.pax.salutation + '_' + item.ticket.idTicket"
                    :checked="get_RebookingAllPaxCheckboxClicked.includes(String(flightdirection)) && flight.rebookable === true">
                </div>
                <div class="mybox">
                    <h4 class="paxheadline" style="margin-bottom: 0px;" v-bind:class="{ flightIsNotRebookable: flight.rebookable === false }">
                        {{ trnslPaxSalutations(item.pax.salutation) }} {{ item.pax.firstName }} {{ item.pax.lastName }} ({{ born[getCurrentLocale] }}: {{ item.pax.birthdate | birthdate }})
                    </h4>
                </div>
            </div>


            <!-- >>> 'Pax Table Services' ---------------------------------- -->
            <div class="table-cell cruise-itinerary" v-bind:class="{ flightIsNotRebookable: flight.rebookable === false }">
                <div class="sdr-box" style="padding-top: 0px; padding-bottom:30px; padding-left: 0px; padding-right: 0px;">
                    <table>
                        <tbody>
                            <!-- flight  -->
                            <tr v-if="whichcall === 'getbooking'">
                                <td>{{ flightpriceservices[getCurrentLocale] }}</td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small"> - </td>
                            </tr>




                            <!-- >>> rebookingprice - A (wo INPUT) --------- -->
                            <tr v-if="whichcall === 'getrebookingkey' && mode !== 'ownprices'">
                                <td><b>{{ flightpricedifference[getCurrentLocale] }}</b></td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small" style="padding-right: 6px;">{{ item.ticket.rebookingPrice  !== undefined ? parseFloat(item.ticket.rebookingPrice , 10) : '0' | rndAmntRUAFWZ }}</td>
                            </tr>
                            <!-- <<< rebookingprice - A (wo INPUT) --------- -->
                            <!-- >>> rebookingprice - B (with INPUT) ------- -->
                            <tr v-if="whichcall === 'getrebookingkey' && mode === 'ownprices'">
                                <td><b>{{ flightpricedifference[getCurrentLocale] }}</b></td>
                                <td class="total-price-value-small" style="padding-right: 25px; color: #2d3e52; font-weight: stronger;" v-once>{{ item.ticket.rebookingPrice  !== undefined ? parseFloat(item.ticket.rebookingPrice , 10) : '0' | rndAmntRUAFWZ }}</td>
                                <td class="total-price-value-small">
                                    <input type="number" step=".01" class="input-text" style="text-align: right; padding-right: 0px;" v-model="item.ticket.rebookingPrice">
                                </td>
                            </tr>
                            <!-- >>> rebookingprice - B (with INPUT) ------- -->


                            <!-- >>> rebooking fee - A (wo INPUT) ---------- -->
                            <tr v-if="whichcall === 'getrebookingkey' && mode !== 'ownprices'">
                                <td><b>{{ rebookingfee[getCurrentLocale] }}</b></td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small" style="padding-right: 6px;">{{ item.ticket.rebookingFee  !== undefined ? parseFloat(item.ticket.rebookingFee , 10) : '0' | rndAmntRUAFWZ }}</td>
                            </tr>
                            <!-- <<< rebooking fee - A (wo INPUT) ---------- -->
                            <!-- >>> rebooking fee - B (with INPUT) -------- -->
                            <tr v-if="whichcall === 'getrebookingkey' && mode === 'ownprices'">
                                <template v-if="(get_RebookingUsersSearchDataGetRebookingKey.idTicketOutwards.length > 0 && index === 0 && flightdirection === 'outward') || (get_RebookingUsersSearchDataGetRebookingKey.idTicketOutwards.length === 0 && get_RebookingUsersSearchDataGetRebookingKey.idTicketReturn.length > 0 && index === 0 && flightdirection === 'return')">
                                    <td style="background-color: antiquewhite;"><b>{{ rebookingfeeforall[getCurrentLocale] }}</b></td>
                                    <td style="background-color: antiquewhite; padding-right: 25px; color: #2d3e52; font-weight: stronger;" class="total-price-value-small" v-once>{{ item.ticket.rebookingFee  !== undefined ? parseFloat(item.ticket.rebookingFee , 10) : '0' | rndAmntRUAFWZ }}</td>
                                    <td style="background-color: antiquewhite;" class="total-price-value-small">
                                        <input type="number" step=".01" class="input-text" style="background-color: antiquewhite; text-align: right; padding-right: 0px;" v-model="item.ticket.rebookingFee">
                                    </td>
                                </template>
                                <template v-else>
                                    <td><b>{{ rebookingfee[getCurrentLocale] }}</b></td>
                                    <td class="total-price-value-small"> &nbsp; </td>
                                    <td style="text-align: right;">{{ samelike[getCurrentLocale] }}</td>
                                </template>
                            </tr>
                            <!-- <<< rebooking fee - B (with INPUT) -------- -->




                            <!-- seat  -->
                            <tr v-if="item.ticket.seatServices.length > 0">
                                <td style="width: 60%;">
                                    {{ seat[getCurrentLocale] }}: <b>{{ item.ticket.seatServices[0].seatIdentifyer.number + '' + item.ticket.seatServices[0].seatIdentifyer.letter| truncate(17, '...') }}</b>
                                    <span style="color: red;" v-if="whichcall === 'getrebookingkey' && item.ticket.seatServices[0].status !== 'CONFIRMED'">&nbsp;&nbsp;({{ seatnotrebookable[getCurrentLocale] }})</span>
                                </td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small" style="padding-right: 6px; color: #2d3e52;">{{ item.ticket.seatServices[0].price !== undefined ? item.ticket.seatServices[0].price : '0' | rndAmntRUAFWZ }}</td>
                            </tr>

                            <!-- infant  -->
                            <tr v-if="item.ticket.infantServices.length > 0">
                                <td style="width: 60%;">{{ infant[getCurrentLocale] }}: <b>({{ item.ticket.infantServices[0].firstName + ' ' + item.ticket.infantServices[0].lastName | truncate(27, '...') }})</b></td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small" style="padding-right: 6px; color: #2d3e52;">{{ item.ticket.infantServices[0].price !== undefined ? item.ticket.infantServices[0].price : '0' | rndAmntRUAFWZ }}</td>
                            </tr>

                            <!-- services -->
                            <tr v-for="(srvcs, index) in item.ticket.services" v-bind:key="index">
                                <td style="width: 60%;">{{ srvcs.description }} <b>({{ paid[getCurrentLocale] }})</b></td>
                                <td style="text-transform: none;"><span v-if="srvcs.quantity > 1">{{ srvcs.quantity }}x a {{ srvcs.price | rndAmntRUAFWZ }}</span></td>
                                <td class="total-price-value-small" style="padding-right: 6px; color: #2d3e52;">{{ srvcs.price !== undefined ? parseFloat(srvcs.price) * parseFloat(srvcs.quantity) : '0' | rndAmntRUAFWZ }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo', 'flight', 'flightdirection', 'mode', 'whichcall'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                // >>> --------------------------
                mr: {
                    en: 'Mr',
                    de: 'Herr',
                },
                mrs: {
                    en: 'Mrs',
                    de: 'Frau',
                },
                chd: {
                    en: 'Child',
                    de: 'Kind',
                },
                inf: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                // >>> --------------------------
                born: {
                    en: 'Born',
                    de: 'Geb. am',
                },
                // >>> --------------------------
                flightpriceservices: {
                    en: 'Flight already booked',
                    de: 'Flug schon gebucht',
                },
                flightpricedifference: {
                    en: 'Flight already booked',
                    de: 'Flug schon gebucht',
                },
                seat: {
                    en: 'Seat',
                    de: 'Sitz',
                },
                infant: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                paid: {
                    en: 'paid',
                    de: 'bezahlt'
                },
                // >>> --------------------------
                rebookingfee: {
                    en: 'Rebooking fee',
                    de: 'Umbuchungsgebühr',
                },
                rebookingfeeforall: {
                    en: 'Rebooking fee for all',
                    de: 'Umbuchungsgebühr für alle',
                },
                flightpricedifference: {
                    en: 'Price difference flight',
                    de: 'Preisdifferenz Flug',
                },
                seatnotrebookable: {
                    en: 'Attention: This seat cannot be rebooked!',
                    de: 'Achtung: Dieser Sitz kann nicht umgebucht werden!'
                },
                samelike: {
                    en: 'Same rebooking fee',
                    de: 'Gleiche Umbuchungsgebühr'
                }
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'get_RebookingTickets',
                'get_RebookingAllPaxCheckboxClicked',
                'getRebookingOriginalBookingRebookingFee',
                'get_RebookingUsersSearchDataGetRebookingKey',



            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * trnslPaxSalutations()
            *
            * Desc:
            *
            * @param
            * @return {Array}
            */
            trnslPaxSalutations: function(type) {

                var me = this,
                    trnsltdSalutation = '';


                me.$toc('>>> booking/overview/FlightDetails.vue >>> trnslPaxSalutations');
                switch(type) {
                case 'MR':
                    trnsltdSalutation = me.mr[me.getCurrentLocale];
                    break;
                case 'MRS':
                    trnsltdSalutation = me.mrs[me.getCurrentLocale];
                    break;
                case 'CHD':
                    trnsltdSalutation = me.chd[me.getCurrentLocale];
                    break;
                case 'INF':
                    trnsltdSalutation = me.inf[me.getCurrentLocale];
                    break;
                default:
                    trnsltdSalutation = '';
                }


                return trnsltdSalutation;

            }, // eo function trnslPaxSalutations()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .flightIsNotRebookable {
        opacity: 0.3;
    }


    /* Price Table */
    .cruise-itinerary td {
        line-height: 1.8em;
        border: 1px solid #f5f5f5;
    }


    .total-price-value-small {
        color: #98ce44;
        font-size: 1.4em;
        text-align: right;
    }

    .outerbox {
        width: 100%;
        background-color: #f5f5f5;
        padding: 5px;
        height: 40px;
    }

    .mybox {
        float: left;
        background-color: #f5f5f5;
        padding: 5px;
    }


    input[type=checkbox] {
        transform: scale(1.2);
    }



    button[disabled], html input[disabled] {
        cursor: default;
        opacity: 0.4;
    }
</style>
